<!-- eslint-disable vue/multi-word-component-names -->
<!-- Layout filenames are fixed by the house structure spec (Default / Blank / Topbar),
     so the multi-word rule cannot apply to this folder.

     One column, no sidebar, no drawer. This portal is held in one hand in a corridor:
     the reception layout's chrome — 64 px of navigation rail plus a hamburger that
     opens a second copy of it — would spend the screen on getting somewhere, and there
     is only one place to be. Navigation appears here when there is a second screen to
     navigate to, and not before: a housekeeper has one screen and sees no tabs at all,
     a supervisor has two and gets them. -->
<template>
    <div class="flex min-h-dvh flex-col bg-muted">
        <Topbar />

        <nav
            v-if="showNavigation"
            class="sticky top-16 z-10 flex shrink-0 gap-1 border-b border-default bg-default px-2 py-1.5 sm:px-4"
        >
            <UButton
                v-for="item in navigation"
                :key="item.name"
                :to="{ name: item.name }"
                :label="item.label"
                :icon="item.icon"
                :color="route.name === item.name ? 'primary' : 'neutral'"
                :variant="route.name === item.name ? 'subtle' : 'ghost'"
                :ui="{ label: 'truncate' }"
                size="lg"
                class="min-w-0 flex-1 justify-center gap-1.5 px-1.5"
            />
        </nav>

        <main class="min-w-0 flex-1 p-3 sm:p-4">
            <slot>
                <RouterView />
            </slot>
        </main>
    </div>
</template>

<script lang="ts" setup>
    import { computed } from 'vue'
    import { useI18n } from 'vue-i18n'
    import { useRoute } from 'vue-router'

    import Topbar from '@/layouts/components/Topbar.vue'
    import { Permission } from '@/enums/permission'
    import { useAppStore } from '@/stores/app'

    const { t }    = useI18n()
    const route    = useRoute()
    const appStore = useAppStore()

    /**
     * Each tab is gated by what it needs, and the strip appears when more than one
     * survives. That is what makes a single-purpose account single-purpose: a
     * housekeeper has one screen and sees no tabs, a handyman has one screen and sees
     * none either — a different one — and a supervisor who also mends things gets all
     * five.
     */
    const navigation = computed(() => [
        { name: 'services', label: t('nav.services'), icon: 'i-lucide-sparkles',      permission: Permission.FacilityWork },
        { name: 'calendar', label: t('nav.calendar'), icon: 'i-lucide-calendar-days', permission: Permission.FacilityWork },
    ].filter(item => appStore.can(item.permission)))

    const showNavigation = computed(() => navigation.value.length > 1)
</script>
